import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import RenderMd from '../../util/markdown';
import ApiService from '../../services/ApiService';
import FileList from '../form/misc/FileList';
import config from '../../config';

interface PageAttachment {
  id: number;
  name: string;
  description: string;
  body: string;
}

interface Props {
  pageAttachments: PageAttachment[];
}

const PageAttachments = ({ pageAttachments }: Props) => {
  const [attachments, setAttachments] = useState({});

  useEffect(() => {
    const promises: any[] = [];
    const attachmentsObj = {};

    for (const pageAttachment of pageAttachments) {
      promises.push(
        ApiService.get(`list/attachments/entity/PageAttachment/item/${pageAttachment.id}`).then(response => {
          attachmentsObj[pageAttachment.id] = response.data;
        })
      );
    }

    Promise.all(promises).then(() => {
      setAttachments(attachmentsObj);
    });
  }, []);

  const select = (...args: any) => {
    const [event, attachment] = args;

    event.stopPropagation();
    const currentAttachment = attachment.photo;
    // TODO Lightbox Open/Download
    if (currentAttachment && currentAttachment.src) {
      window.open(`${attachment.photo.src}/download`, '_new');
    } else {
      window.open(`${config.serverUrl}/api/attachment/${attachment.key}/download`);
    }
  };

  return pageAttachments.map(pageAttachment => {
    return (
      <Card className="mb-3" key={pageAttachment.id}>
        <Card.Header>
          <Card.Title>
            <b>{pageAttachment.name}</b>
            {!!pageAttachment.description && ` - ${pageAttachment.description}`}
          </Card.Title>
        </Card.Header>
        <Card.Body>
          {!!pageAttachment.body && <RenderMd md={pageAttachment.body} />}
          <hr />
          {attachments[pageAttachment.id] && (
            <FileList files={attachments[pageAttachment.id]} onClick={select} readOnly disableDrag />
          )}
        </Card.Body>
      </Card>
    );
  });
};

export default PageAttachments;
